import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: 'Is Vitality 360™ Right for Your Family?',
    a: 'Vitality 360™ may be a good fit if you:\n\n✓ Care for an older parent or family member at home\n✓ Want simple ways to encourage movement and mental engagement\n✓ Need ready-to-use activities instead of more research\n✓ Want to create a more consistent daily routine\n✓ Would like practical tools to stay organized as a caregiver'
  }, {
    q: 'Is this a physical book?',
    a: 'No, it is a 100% digital system for instant access. Print the 150+ sheets whenever you need them.'
  }, {
    q: "Does it work for Dementia or Alzheimer's?",
    a: 'The activities are designed to be adapted to different ability levels, with large print and simple instructions, so you can choose what feels appropriate on any given day. They are a practical way to add gentle mental stimulation to a daily routine, not a medical treatment. Always follow the guidance of your healthcare provider.'
  }, {
    q: 'Is it easy to use?',
    a: 'Absolutely. We designed it for families, not doctors. Clear instructions and large print.'
  }, {
    q: 'What is the guarantee?',
    a: "You have 60 days to test the system. If you aren't satisfied, we refund 100% of your money."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-57" data-mp="1jk6qidp7h8by">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-58" data-mp="1xjzbdse1wuc0">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-59" data-mp="1xjfxqnvfos3s">
          ❓ FREQUENTLY ASKED QUESTIONS
        </h2>
        <div className="space-y-2 md:space-y-4" data-id="element-60" data-mp="3556k8rd9luu">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-cyan bg-familia-card' : 'border-familia-cyan/25 bg-familia-bg'}`} data-id="element-61" data-mp="3ueccyeak0dkn" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-62" data-mp="286rbz5j8o3rz">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-63" data-mp="2h7616fzbq30r">
                    {faq.q}
                  </span>
                  <span className={`text-familia-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-64" data-mp="2m57h4s1gdm80">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-65" data-mp="2zyyte86kjk7f">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-66" data-mp="2zwm4fb2e89kv">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-familia-gray text-[14px] sm:text-base leading-relaxed border-t border-white/10 whitespace-pre-line" data-id="element-67" data-mp="1bzmnu27h16hy">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};